import { fetchUserProfile } from "@/lib/user/fetchUserProfile";
import * as Sentry from "@sentry/react";
import { useQuery } from "@tanstack/react-query";
import { getAuth } from "firebase/auth";
import { useSigninCheck } from "reactfire";

export const USER_PROFILE_KEY = "user";

const useUserProfile = () => {
  const auth = getAuth();
  const { status, data } = useSigninCheck();

  const { isLoading } = useQuery({
    queryKey: [USER_PROFILE_KEY],
    queryFn: () => fetchUserProfile(auth.currentUser?.uid || ""),
    enabled: status === "success" && data.signedIn,
    onError: Sentry.captureException,
  });

  return isLoading;
};

export default useUserProfile;
